// Простой i18n: dict + localStorage + custom event 'i18n:change'.

type Dict = Record<string, string>;

const EN: Dict = {
  // nav
  "nav.chat": "Chat",
  "nav.credits": "Credits",
  "nav.login": "Sign in",
  // chat
  "chat.placeholder": "Type a message…",
  "chat.send": "Send",
  "chat.empty.login": "Sign in with Telegram —",
  "chat.thinking": "💭 Thinking…",
  "chat.empty_reply": "🤖 Empty.",
  "chat.no_credits": "⛔ Out of credits. Open «Credits» and top up your balance.",
  "chat.clear": "Clear chat",
  "chat.clear_confirm": "Clear this chat history?",
  "chat.clear_error": "Could not clear chat: {msg}",
  "chat.api_unavailable": "API unavailable: {msg}",
  "chat.tool_running": "running",
  "chat.tool_done": "done",
  "chat.continuing": "Continuing…",
  "chat.choice_submit": "Continue",
  "chat.choice_error": "Could not submit the choice",
  "chat.resume_timeout": "Timed out waiting for the continuation",
  "chat.auth_title": "Continue in Telegram",
  "chat.auth_text": "The free limit is over. Link Telegram and return here.",
  "chat.sub_title": "Subscription required",
  "chat.sub_text": "The subscription-free limit is over. Activate access in the bot.",
  "chat.open_telegram": "Open Telegram",
  "chat.temp_error": "Temporary server error",
  // login
  "login.title": "Sign in with Telegram",
  "login.subtitle": "I'll open the bot — confirm there, you'll return here automatically.",
  "login.open_tg": "Open Telegram",
  "login.waiting": "Waiting for confirmation…",
  "login.expired": "Link expired — refresh the page.",
  "login.timeout": "Timeout. Please try again.",
  "login.creating": "Creating link…",
  "login.error": "Error: {msg}",
  // billing
  "billing.title": "Credits",
  "billing.balance": "Balance",
  "billing.balance_meta": "≈ ${usd} · 1 credit = ${rate}",
  "billing.open_chat": "Open chat",
  "billing.topup_title": "Top up via TON",
  "billing.address": "Address:",
  "billing.memo": "Memo:",
  "billing.history_title": "Payment history",
  "billing.history_empty": "No payments yet.",
  "billing.col_when": "When",
  "billing.col_ton": "TON",
  "billing.col_credits": "Credits",
  "billing.col_tx": "Tx",
  "billing.movement_title": "Credit movements",
  "billing.movement_empty": "No transactions yet.",
  "billing.col_change": "Change",
  "billing.col_reason": "Reason",
  "billing.pack_cta": "Open in wallet",
  "billing.first_login": "Sign in first —",
  // MCP access
  "mcp.title": "MCP and legacy API access",
  "mcp.description": "One key works with MCP JSON-RPC and legacy HTTP clients. Authorization: Bearer, X-API-Token and X-API-Key are supported.",
  "mcp.tier": "Tier:",
  "mcp.rate": "Rate limit:",
  "mcp.key": "Active key:",
  "mcp.limit": "{count} requests / {seconds} sec",
  "mcp.budget": "{count} credits / rolling 24h",
  "mcp.unlimited": "Unlimited",
  "mcp.shown_once": "Save this key now. It will not be shown again.",
  "mcp.copy": "Copy key",
  "mcp.copied": "Copied",
  "mcp.create": "Create API key",
  "mcp.rotate": "Rotate key",
  "mcp.revoke": "Revoke",
  "mcp.confirm_rotate": "The current key will stop working immediately. Rotate it?",
  "mcp.confirm_revoke": "The current key will stop working immediately. Revoke it?",
  // subscription
  "sub.title": "Subscription",
  "sub.active": "Active:",
  "sub.active_until": "until {date}",
  "sub.inactive": "No active subscription",
  "sub.best_value": "Best value",
  "sub.buy": "Buy",
  "sub.show_details": "Details",
  "sub.tier.try": "Try without commitment",
  "sub.tier.optimal": "Best for regular analysis",
  "sub.tier.pro": "For heavy users and traders",
  "sub.tier.single": "Full access to the assistant",
  "sub.feat.access_days": "Access for <b>{days}</b> day(s)",
  "sub.feat.all_tools": "All Telegram Gifts analytics tools",
  "sub.feat.no_limits": "No daily limits",
  "sub.feat.priority": "Priority request processing",
  "sub.feat.support": "Direct support in DMs",
  // pay modal
  "pay.title": "Subscription payment — {name}",
  "pay.subtitle": "Access for {days} day(s)",
  "pay.wallet": "Wallet:",
  "pay.memo": "Memo (required!):",
  "pay.amount": "Amount:",
  "pay.copy": "Copy",
  "pay.copied": "✓ Copied",
  "pay.copy_failed": "Failed",
  "pay.open_wallet": "Open in TON wallet",
  "pay.waiting": "Waiting for payment…",
  "pay.success": "✓ Subscription activated! Refreshing…",
  "pay.timeout": "Timed out. If you already paid — refresh in a minute.",
  "pay.instructions": "Send TON to the address with the specified memo — subscription activates automatically in 1–2 minutes after the network confirms.",
  // empty
  "common.not_found": "Not found",
};

const RU: Dict = {
  "nav.chat": "Чат",
  "nav.credits": "Кредиты",
  "nav.login": "Войти",
  "chat.placeholder": "Напиши сообщение…",
  "chat.send": "Отправить",
  "chat.empty.login": "Войди через Telegram —",
  "chat.thinking": "💭 Думаю…",
  "chat.empty_reply": "🤖 Пусто.",
  "chat.no_credits": "⛔ Нет кредитов. Открой раздел «Кредиты» и пополни баланс.",
  "chat.clear": "Очистить чат",
  "chat.clear_confirm": "Очистить историю этого чата?",
  "chat.clear_error": "Не удалось очистить чат: {msg}",
  "chat.api_unavailable": "API недоступен: {msg}",
  "chat.tool_running": "выполняется",
  "chat.tool_done": "готово",
  "chat.continuing": "Продолжаю…",
  "chat.choice_submit": "Продолжить",
  "chat.choice_error": "Не удалось отправить выбор",
  "chat.resume_timeout": "Истекло время ожидания продолжения",
  "chat.auth_title": "Продолжи через Telegram",
  "chat.auth_text": "Бесплатный лимит закончился. Привяжи Telegram и вернись сюда.",
  "chat.sub_title": "Нужна подписка",
  "chat.sub_text": "Лимит без подписки закончился. Оформи доступ в боте.",
  "chat.open_telegram": "Открыть Telegram",
  "chat.temp_error": "Временная ошибка сервера",
  "login.title": "Войти через Telegram",
  "login.subtitle": "Откроется бот, подтверди вход — и вернёшься сюда автоматически.",
  "login.open_tg": "Открыть Telegram",
  "login.waiting": "Ожидание подтверждения…",
  "login.expired": "Ссылка истекла — обнови страницу.",
  "login.timeout": "Время ожидания истекло.",
  "login.creating": "Создаю ссылку…",
  "login.error": "Ошибка: {msg}",
  "billing.title": "Кредиты",
  "billing.balance": "Баланс",
  "billing.balance_meta": "≈ ${usd} · 1 кр = ${rate}",
  "billing.open_chat": "Открыть чат",
  "billing.topup_title": "Пополнение через TON",
  "billing.address": "Адрес:",
  "billing.memo": "Memo:",
  "billing.history_title": "История платежей",
  "billing.history_empty": "Платежей пока нет.",
  "billing.col_when": "Когда",
  "billing.col_ton": "TON",
  "billing.col_credits": "Кредиты",
  "billing.col_tx": "Tx",
  "billing.movement_title": "Движение кредитов",
  "billing.movement_empty": "Транзакций пока нет.",
  "billing.col_change": "Изменение",
  "billing.col_reason": "Причина",
  "billing.pack_cta": "Открыть в кошельке",
  "billing.first_login": "Сначала войди —",
  "mcp.title": "Доступ к MCP и legacy API",
  "mcp.description": "Один ключ работает с MCP JSON-RPC и старыми HTTP-клиентами. Поддерживаются Authorization: Bearer, X-API-Token и X-API-Key.",
  "mcp.tier": "Тариф:",
  "mcp.rate": "Лимит:",
  "mcp.key": "Активный ключ:",
  "mcp.limit": "{count} запросов / {seconds} сек",
  "mcp.budget": "{count} кредитов / скользящие 24 ч",
  "mcp.unlimited": "Без ограничений",
  "mcp.shown_once": "Сохрани ключ сейчас. Повторно он показан не будет.",
  "mcp.copy": "Скопировать ключ",
  "mcp.copied": "Скопировано",
  "mcp.create": "Создать API-ключ",
  "mcp.rotate": "Перевыпустить ключ",
  "mcp.revoke": "Отозвать",
  "mcp.confirm_rotate": "Текущий ключ сразу перестанет работать. Перевыпустить его?",
  "mcp.confirm_revoke": "Текущий ключ сразу перестанет работать. Отозвать его?",
  "sub.title": "Подписка",
  "sub.active": "Активна:",
  "sub.active_until": "до {date}",
  "sub.inactive": "Подписки нет",
  "sub.best_value": "Лучшая цена",
  "sub.buy": "Купить",
  "sub.show_details": "Реквизиты",
  "sub.tier.try": "Попробовать без обязательств",
  "sub.tier.optimal": "Оптимально для регулярного анализа",
  "sub.tier.pro": "Для тяжёлых юзеров и трейдеров",
  "sub.tier.single": "Полный доступ к ассистенту",
  "sub.feat.access_days": "Доступ на <b>{days}</b> {plural}",
  "sub.feat.all_tools": "Все тулзы аналитики Telegram Gifts",
  "sub.feat.no_limits": "Без дневных лимитов",
  "sub.feat.priority": "Приоритетная обработка запросов",
  "sub.feat.support": "Поддержка в личке",
  "pay.title": "Оплата подписки — {name}",
  "pay.subtitle": "Доступ на {days} {plural}",
  "pay.wallet": "Кошелёк:",
  "pay.memo": "Memo (обязательно!):",
  "pay.amount": "Сумма:",
  "pay.copy": "Скопировать",
  "pay.copied": "✓ Скопировано",
  "pay.copy_failed": "Не удалось",
  "pay.open_wallet": "Открыть в TON-кошельке",
  "pay.waiting": "Жду оплату…",
  "pay.success": "✓ Подписка активирована! Обновляю…",
  "pay.timeout": "Время ожидания истекло. Если ты уже оплатил — обнови страницу через минуту.",
  "pay.instructions": "Отправь TON на адрес с указанным memo — подписка активируется автоматически в течение 1–2 минут после подтверждения сети.",
  "common.not_found": "Не найдено",
};

const LANGS: Record<string, Dict> = { en: EN, ru: RU };
const KEY = "gifty_lang";

function detect(): string {
  const stored = localStorage.getItem(KEY);
  if (stored && LANGS[stored]) return stored;
  const nav = (navigator.language || "en").toLowerCase().split("-")[0];
  return LANGS[nav] ? nav : "en";
}

let _lang = detect();

export function getLang(): string { return _lang; }

export function setLang(lang: string): void {
  if (!LANGS[lang]) return;
  _lang = lang;
  localStorage.setItem(KEY, lang);
  document.documentElement.lang = lang;
  window.dispatchEvent(new CustomEvent("i18n:change", { detail: { lang } }));
}

export function t(key: string, vars?: Record<string, string | number>): string {
  const dict = LANGS[_lang] || EN;
  let tpl = dict[key] || EN[key] || key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      tpl = tpl.replaceAll(`{${k}}`, String(v));
    }
  }
  return tpl;
}

export function pluralDays(n: number): string {
  if (_lang === "ru") {
    const m = n % 10, h = n % 100;
    if (h >= 11 && h <= 14) return "дней";
    if (m === 1) return "день";
    if (m >= 2 && m <= 4) return "дня";
    return "дней";
  }
  return n === 1 ? "day" : "days";
}

export function langOptions(): { code: string; label: string }[] {
  return [
    { code: "en", label: "EN" },
    { code: "ru", label: "RU" },
  ];
}

document.documentElement.lang = _lang;
